import { useCallback, useMemo } from 'react';
import { sprintf } from 'sprintf-js';

import { TrackedDropdownMenuItem } from 'components/Page/Header/PageHeaderDropdownMenu';
import { LANGUAGES } from 'utils/constants';
import { createCookie } from 'utils/cookies';

type Props = {
  locale: UserLocale;
  localeUrl: string | undefined;
};

export function LanguageSelectionMenuItem({ locale, localeUrl }: Props) {
  const title = useMemo(() => {
    if (!localeUrl) {
      return sprintf(
        /* TRANSLATORS: Tooltip message letting user know page is not yet
         * translated when hovering over disabled language selection link. */
        getText('This page is not translated in %(languages)s'),
        { languages: LANGUAGES[locale] },
      );
    }

    return '';
  }, [locale, localeUrl]);

  const select = useCallback(
    () => createCookie('_LOCALE_', locale, 1825),
    [locale],
  );

  const qaId = useMemo(
    () =>
      localeUrl ? `locale-link-${locale}` : `disabled-locale-link-${locale}`,
    [locale, localeUrl],
  );

  return (
    <TrackedDropdownMenuItem
      disabled={!localeUrl}
      // @ts-expect-error TS(2769): No overload matches this call.
      href={localeUrl || null}
      onClick={select}
      title={title}
      data-qa-id={qaId}
      eventName={localeUrl ? 'Change Language' : undefined}
      eventProperties={localeUrl ? { locale } : undefined}
    >
      {LANGUAGES[locale]}
    </TrackedDropdownMenuItem>
  );
}
